export default __webpack_public_path__ + "static/media/article-created.d55a39bc.svg";